import forEach from 'lodash/forEach'
import kebabCase from 'lodash/kebabCase'

const baseApiUrl = process.env.VUE_APP_API_URL || ''

type Parameters = { [key: string]: any }

export class ApiRouteGenerator {
  public generateAdminRoute(modelName: string, parameters?: Parameters) {
    return `${baseApiUrl}/admin/${this.getUrl(modelName, parameters)}`
  }

  public generateRoute(modelName: string, parameters?: Parameters) {
    return `${baseApiUrl}/${this.getUrl(modelName, parameters)}`
  }

  private getUrl(prefix: string, parameters?: Parameters) {
    let stringParams = ''

    if (parameters) {
      forEach(parameters, (paramValue) => {
        stringParams += paramValue ? `/${paramValue}` : ''
      })
    }
    return `${kebabCase(prefix)}${stringParams}`
  }
}

export default new ApiRouteGenerator()
